module.exports = "/images/logotype-expensify.svg?20edf86ebbc6450384ee03dc26517254";